export class WindowUtil {

    static async loadScript(url: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            let isDone = false;
            let script = document.createElement('script');
            let errorHandler = (evt: ErrorEvent) => {
                if (!isDone && evt.error?.stack?.includes(url)) {
                    isDone = true;
                    reject(evt.error);
                }

                window.removeEventListener('error', errorHandler);
            };

            script.onload = (ev) => {
                if (!isDone) {
                    isDone = true;
                    resolve();
                    window.removeEventListener('error', errorHandler);
                }
            };

            window.addEventListener('error', errorHandler);

            script.src = url;
            document.body.appendChild(script);
            return;
        });
    }
}
